import React from 'react'
import { Link } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import messages from './messages'

import AppTools from 'utils/app/appTools'
import APPURL from 'utils/app/urls'
import IndicatorTools from 'utils/indicators/indicatorTools'

const Breadcrumbs = props => {
  const {
    intl: { formatMessage }
  } = props

  this.formatMessage = formatMessage
  AppTools.importFormatter(formatMessage)

  const path = props.history.location.pathname
  const currentLayer = APPURL.getLayerFromURL(path)
  const closeMenuOffCanvas = props.closeMenuOffCanvas

  const renderIfAllOK = () => {
    let renderingComponent = null
    if (props.responsive) {
      renderingComponent = <ul className="breadcrumb ork-menu-off-canvas__breadcrumb">{renderBreadcrumbs()}</ul>
    } else {
      renderingComponent = <ul className="breadcrumb hidden-xs hidden-sm">{renderBreadcrumbs()}</ul>
    }
    return renderingComponent
  }

  const renderBreadcrumbs = () => {
    switch (currentLayer) {
    case 1:
      return loadLayer1()
    case 2:
      return loadLayer2()
    case 3:
      return loadLayer3()
    case 'methodology':
      return loadMethodology()
    default:
      return ''
    }
  }

  const loadLayer1 = () => {
    const homeLink = APPURL.getHomeLink(path)
    return (
      <React.Fragment>
        <li>
          <Link to={homeLink} onClick={closeMenuOffCanvas}>
            {this.formatMessage(messages.home)}
          </Link>
        </li>
        <li className="active">{this.formatMessage(messages.layer1PageName)}</li>
      </React.Fragment>
    )
  }

  const loadLayer2 = () => {
    const homeLink = APPURL.getHomeLink(path)
    const urlHead = APPURL.getUrlHead(path)
    const level = APPURL.getLevelFromURL(path)
    const dimensionTitle = AppTools.getDimensionTitle(level)
    return (
      <React.Fragment>
        <li>
          <Link to={homeLink} onClick={closeMenuOffCanvas}>
            {this.formatMessage(messages.home)}
          </Link>
        </li>
        <li>
          <Link to={urlHead} onClick={closeMenuOffCanvas}>
            {this.formatMessage(messages.layer1PageName)}
          </Link>
        </li>
        <li className="active">{dimensionTitle}</li>
      </React.Fragment>
    )
  }

  const loadLayer3 = () => {
    const homeLink = APPURL.getHomeLink(path)
    const urlHead = APPURL.getUrlHead(path)
    const indicator = APPURL.getIndicatorFromURL(path)
    // const dimension = IndicatorTools.getDimensionFromIndicator( indicator );
    const panel_index = IndicatorTools.getIndicatorIndexInPanel( indicator );
    const dimensionTitle = AppTools.getDimensionTitle( panel_index[0] );
    const subDimensionTitle = AppTools.getSubDimensionTitle( panel_index[0], panel_index[1] );

    const newURL = APPURL.getLevelDetailLink({ url: urlHead, level: panel_index[0] });

    if (props.indicatorsData === undefined) {
      return
    } else {
      const indicatorData = props.indicatorsData.filter(item => Number(item.id) === Number(indicator))[0]
      const indicatorName = indicatorData.name
      return (
        <React.Fragment>
          <li>
            <Link to={homeLink} onClick={closeMenuOffCanvas}>
              {this.formatMessage(messages.home)}
            </Link>
          </li>
          <li>
            <Link to={urlHead} onClick={closeMenuOffCanvas}>
              {this.formatMessage(messages.layer1PageName)}
            </Link>
          </li>
          <li>
            <Link to={newURL} onClick={closeMenuOffCanvas}>
              {dimensionTitle} - {subDimensionTitle}
            </Link>
          </li>
          <li className="active">{indicatorName}</li>
        </React.Fragment>
      )
    }
  }

  const loadMethodology = () => {
    const homeLink = APPURL.getHomeLink(path)
    return (
      <React.Fragment>
        <li>
          <Link to={homeLink} onClick={closeMenuOffCanvas}>
            {this.formatMessage(messages.home)}
          </Link>
        </li>
        <li className="active">{this.formatMessage(messages.methodology)}</li>
      </React.Fragment>
    )
  }

  return <React.Fragment>{renderIfAllOK()}</React.Fragment>
}
export default injectIntl(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js